import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import CookieService from "../../service/cookieService";

const cookieService = CookieService.getService();
const validateUserName = (payload) => trackPromise(Call.post(getUrl("login"), payload));
const forgetPasswordValidation = (payload) =>
  trackPromise(Call.post(getUrl("forgetPassword"), payload));
const resetPassword = (payload) =>
  trackPromise(Call.post(getUrl("resetPassword"), payload));
const validateToken = (payload) =>
  trackPromise(Call.post(getUrl("resetPassword"), payload));
const validateOTP = (payload) => trackPromise(Call.post(getUrl("login"), payload));
const login = (payload) =>
  trackPromise(
    Call.post(getUrl("login"), payload).then(({data}) => {
      cookieService.setToken(data.data, payload.rememberMe);
      return data;
    })
  );

export default {
  validateUserName,
  resetPassword,
  validateToken,
  forgetPasswordValidation,
  validateOTP,
  login,
};

export const verifyEmailAsync = (data) => {
  return trackPromise(Call.post(getUrl("verifyEmail"), data));
};

export const verifyTokenAsync = (data) => {
  return trackPromise(Call.post(getUrl("verifyToken"), data));
};

export const resetPasswordAsync = (data) => {
  return trackPromise(Call.post(getUrl("resetPassword"), data));
};
